'use client';

import 'byway-design-tokens/src/index.css';
import '~/assets/main.css';

import { NextIntlClientProvider, useTranslations } from 'next-intl';
import { useEffect } from 'react';
import { Button } from '~/components/Button';
import { Heading } from '~/components/Heading';
import { claimErrorReload, logError, reloadAfterLogging } from '~/utils';
import messages from '../messages/en-GB.json';
import styles from './global-error.module.css';

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    const shouldReload = claimErrorReload(error.digest);
    const logged = logError(error);
    if (shouldReload) reloadAfterLogging(logged);
  }, [error]);

  // global-error replaces the root layout, so no intl provider or lang attribute is inherited.
  // Fixed to the default locale: a failure this severe shouldn't depend on locale resolution.
  return (
    <html lang="en-GB">
      <body data-theme="light" className="font-sans">
        <NextIntlClientProvider locale="en-GB" messages={{ errors: messages.errors }}>
          <ServerError reset={reset} />
        </NextIntlClientProvider>
      </body>
    </html>
  );
}

function ServerError({ reset }: { reset: () => void }) {
  const t = useTranslations('errors');

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <p className={styles.statusCode}>500</p>
        <div className={styles.title}>
          <Heading level="h1" variant="heading-xl">
            {t('server_error_title')}
          </Heading>
        </div>
        <p className={styles.description}>{t('server_error_description')}</p>
        <div className={styles.buttonContainer}>
          <Button onPress={reset}>{t('try_again')}</Button>
        </div>
      </div>
    </div>
  );
}
